export const wmEvents = () => {
  const triggerEvent = (event, options = null) => {
    document.dispatchEvent(new CustomEvent(event, { detail: options }));

    if (window.wemove.isDebugEnabled) {
      console.log(
        `%cWeMove: ${event} event triggered!`,
        "color: #21194f; font-weight: bold"
      );
    }
  };

  window.wemove.triggerEvent = triggerEvent;
};
